import { useAccountQuery } from "features/auth/authApi";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSite } from "../../hooks/use-site";

const OtpChangedCheck: React.FC = () => {
  const { data: account } = useAccountQuery();
  const { optionalTwofa, isSiteLoaded } = useSite();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (
      isSiteLoaded &&
      !optionalTwofa &&
      account?.user.otp_channel_changed &&
      location.pathname !== "/profile"
    ) {
      navigate("/profile");
    }
  });
  return null;
};

export default OtpChangedCheck;
